import { MatchList } from 'ui/components/agent/patterns/MatchList/MatchList';

/**
 * 仲介業者マッチング一覧
 */
export const AgentMatchList: React.FC = () => {
    return <MatchList />;
};
